import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { ICreateVenueAddressBody } from '.';

export const createVenueAddress = async (venueId: string, requestBody: ICreateVenueAddressBody): Promise<void> => {
  const url = `${API_URL}/venues/${venueId}/address`;
  try {
    const res = await fetch(url, {
      method: 'POST',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (res.status !== Status.SUCCESS) {
      const json = await res.json();
      throw new Error(json.message);
    }
  } catch (e) {
    throw new Error(e || 'Unable to create venue address');
  }
  return;
};
